module.exports = __webpack_public_path__ + "img/logo-text-rota-certa.a8a7229d.png";